import { RichText } from './component';
import { enhance } from './enhancers';

export default enhance(RichText);
